import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=3c0b908e&"
import script from "./Favorite.vue?vue&type=script&lang=ts&"
export * from "./Favorite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/vsts/work/1/a/NuxtApp/components/base/Button.vue').default})
